import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex justify-center items-center py-20">
            <div className="w-8 h-8 border-2 border-white/10 border-t-red animate-spin" />
        </div>
    );
};

export default LoadingSpinner;
